import { ReactComponent as EditIcon } from '../../Common/BootstrapIcons/edit.svg';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import React from 'react';

const uniqueName = 'master-configuration-grid';

const getColumns = (
    onEditClick: (regime: string) => void,
): ColumnDefinition<string>[] => {

    return [
        {
            header: 'Regime',
            sortKey: 'regime',
            getContent: x => x,
        },
        {
            header: 'Actions',
            getContent: x =>
                <div className='display-flex'>
                    <button className="custom-icon-button" onClick={() => onEditClick(x)}>
                        <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                    </button>
                </div>,
        }
    ];
};

export { getColumns, uniqueName };